import { render, staticRenderFns } from "./officesList.vue?vue&type=template&id=88769064&"
import script from "./officesList.vue?vue&type=script&lang=js&"
export * from "./officesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports